export function handleStakeHelper(stake, setctx) {
  setctx(ctx => {
    return { ...ctx, stake }
  })
}

export function handleClearHelper(setctx, minbet) {
  setctx(ctx => {
    return { ...ctx, stake: minbet.toString() }
  })
}
export function handleAudioHelper(audio, setctx) {
  setctx(ctx => {
    return { ...ctx, audio }
  })
}

export function handleAutoCurrentHelper(autoCurrent, setctx) {
  setctx(ctx => {
    return { ...ctx, autoCurrent }
  })
}

export function handleAutoConfigstHelper(auto, setctx) {
  setctx(ctx => {
    return {
      ...ctx,
      stake: auto.betAmount,
      autoConfigs: { numOfBets: auto.numOfBets, cashoutAt: auto.cashoutAt },
    }
  })
}

export function handleAutoHelper(auto, setAutoConfigs, setAutoCurrent) {
  setAutoConfigs(auto)
  setAutoCurrent({
    betsRemained: auto.numOfBets,
    isAutoOn: true,
  })
}

export function handleFuncsInContext(
  setctx,
  stopAuto,
  handleStake,
  handleClear,
  setAudio,
  handleAuto,
  handleErrorText,
) {
  setctx(ctx => {
    return {
      ...ctx,
      funcs: {
        stopAuto,
        handleStake,
        handleClear,
        setAudio,
        handleAuto,
        handleErrorText,
      },
    }
  })
}
